export enum FormTemplateTypeEnum {
    Register = 1,
    Booking = 2,
    Review = 3,
    TermsandConditions = 4
}